const defaultLabroom = [
  {
    creatorEmail: 'admin@zerolab.com',
    creatorName: 'Science Teacher',
    creatorPhoto: 'https://i.ibb.co/S7vrSdn/u3.png',
    id: 'wcFNfK9blVmh3Y9s8x4A',
    name: 'Physics',
  },
  {
    creatorEmail: 'admin@zerolab.com',
    creatorName: 'Science Teacher',
    creatorPhoto: 'https://i.ibb.co/S7vrSdn/u3.png',
    id: 'iyZfS32eWg6Al8inOzKr',
    name: 'Chemistry',
  },
  {
    creatorEmail: 'creativeiot71@gmail.com',
    creatorName: 'Elon Musk',
    creatorPhoto: 'https://i.ibb.co/20z4pdC/u4.png',
    id: 'SKXZlxcQPgiNbxnTduJv',
    name: 'Biology',
  },
];

export default defaultLabroom;
